export enum WarningType {
  LowDPI = 'LowDPI',
  NotVisible = 'NotVisible',
  OutOfRange = 'OutOfRange',
  MaxStitchCount = 'MaxStitchCount',
  MaxColorCount = 'MaxColorCount',
}
